import { render, staticRenderFns } from "./TodoForm.vue?vue&type=template&id=a2eb0774&"
import script from "./TodoForm.vue?vue&type=script&lang=ts&"
export * from "./TodoForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports